import React from 'react';
import classnames from 'classnames';
import { isBrowser } from 'react-device-detect';

import styles from './index.css';

const Option = ({ className, children, active, reverse, border, onSelect, moreWeight }) => (
	<div
		className={classnames(styles.option, className, {
			[styles.reverse]: reverse,
			[styles.border]: border,
			[styles.active]: active,
			[styles.isBrowser]: isBrowser,
			[styles.isMoreWeight]: moreWeight,
		})}
		role="button"
		tabIndex="0"
		onClick={onSelect}
		onKeyPress={() => {}}
	>
		{children}
	</div>
);

export default Option;



// WEBPACK FOOTER //
// ./src/components/atoms/Option/index.js